module.exports = __webpack_public_path__ + "img/newPadlock2.d05ade9f.svg";